<template>
    <div class="text-toggle-container" :class="{disabled: disabled}">
        <div class="text-toggle-item text-xs" :class="{active: active == 0}" @click="setActive(leftItem.value)">
            {{ leftItem.name }}
        </div>
        <div class="text-toggle-item text-xs" :class="{active: active == 1}" @click="setActive(rightItem.value)">
            {{ rightItem.name }}
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            /**
             * @type {{ name: string, value: any }}
             */
            leftItem: {
                type: Object,
                required: true,
            },
            /**
             * @type {{ name: string, value: any }}
             */
            rightItem: {
                type: Object,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: true
            },
            value: Number,
        },
        data() {
            return {
                active: this.value
            };
        },
        methods: {
            setActive(newValue) {
                if (!this.disabled) {
                    this.active = newValue;
                    this.$emit('input', newValue);
                }
            }
        }
    };
</script>

<style>
    .text-toggle-container {
        display: flex;
        background-color: #FFFFFF20;
        border-radius: 5px;
        width: fit-content;
        padding: 2px;
    }

    .text-toggle-item {
        cursor: pointer;
        border-radius: 3px;
        transition: .3s;
        width: fit-content;
        padding: 5px;
        font-size: 12px;
        color: #FFFFFF80
    }

    .text-toggle-item.active {
        background-color: #f5a621;
        color: #FFFFFF;
    }

    .text-toggle-container.disabled {
        background-color: #FFFFFF15;
    }

    .text-toggle-container.disabled .text-toggle-item {
        color: #565656;
    }

    .text-toggle-container.disabled .text-toggle-item.active {
        background-color: #777;
        color: #999;
    }
</style>